<template>
    <div class="notice_container">
        <!-- <CustomHeader /> -->
        <div class="headIcon">
            <img src="@/assets/themetwo/back.png" alt="" @click="goToHome">
        </div>
        <img src="@/assets/themetwo/f2.png" alt="" />
        <p class="titleHead">{{$t('notice.updateNotification')}}</p>
        <div v-html="$t('notice.contentText')"></div>
    </div>
</template>

<script setup lang="ts">
import CustomHeader from '@/components/common/customHeader.vue';
import { defineEmits } from 'vue'

const emits = defineEmits(['goToHome'])

const goToHome = () => {
    emits('goToHome')
}

</script>
<style scoped>
.notice_container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    color: #76517c;
}

.notice_container img {
    width: 50%;
    padding-bottom: 20px;
}

.headIcon {
    position: fixed;
    top: 20px;
    left: 20px;
    font-size: 25px;
}
.headIcon img{
    width: 50px;
}
.titleHead {
    color: #ffa4d1;
    font-size: 18px;
    font-weight: bold;
}
</style>